<div class="tw-relative tw-h-full">
  <p-card styleClass="tw-h-full tw-relative">
    <ng-template pTemplate="header">
      <p-button
        *ngIf="burtAdmin"
        stopClickPropagation
        [text]="true"
        severity="secondary"
        size="large"
        icon="fa-solid fa-ellipsis-vertical"
        (onClick)="menu.toggle($event)"
        styleClass="tw-z-10 tw-absolute tw-top-2 tw-right-2"
      ></p-button>
    </ng-template>

    <ng-template pTemplate="title">
      {{ template.name }}
    </ng-template>

    <ng-template pTemplate="content">
      <p class="tw-pb-12">{{ template.description }}</p>
    </ng-template>

    <ng-template pTemplate="footer">
      <div class="tw-text-sm tw-text-gray-500 tw-absolute tw-bottom-0 tw-left-0 tw-p-6 tw-w-full">
        <div class="tw-font-bold">Datasets:</div>
        <div class="tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap">
          {{ template.datasetNames?.join(', ') }}
        </div>
      </div>
    </ng-template>
  </p-card>

  <div class="overlay"></div>

  <p-button
    label="Use template"
    class="use-template-button"
    [rounded]="true"
    (onClick)="navigateToTemplate()"
  ></p-button>
</div>

<p-menu
  #menu
  [popup]="true"
  [model]="menuItems"
  appendTo="body"
></p-menu>

<hub-template-save-modal
  title="Update Template"
  [dialogId]="'updateTemplateDialog-' + template.id"
  [app]="type"
  [name]="template.name"
  [description]="template.description"
  [global]="template.global"
  [burtAdmin]="burtAdmin"
  (saveChange)="updateTemplate($event)"
></hub-template-save-modal>
